import { InjectionToken } from '@angular/core';

import { FormSection } from '../typings/form';

export const FORM_SECTION = new InjectionToken<FormSection>('FORM_SECTION');
